import { DesignTokens } from "@heritageholdings/lib-commons-frontend";

/**
 * Palette following the definitive Design System.
 */
export const heritageV2Palette = {
  ...DesignTokens.lightColors,
};
